import { Flex, Heading, HStack, Text, VStack } from "@chakra-ui/react";
import { useQuery } from "@tanstack/react-query";
import { listingsModel } from "models/listings";
import { useParams } from "react-router-dom";
import { useIsAgencyFeaturePreferenceEnabled } from "hooks/use-is-agency-feature-preference-enabled";
import { MarketingFeedbackButtons } from "modules/vendor-portal/screens/marketing/components/marketing-feedback-buttons";

export function MarketingMaterialHeading() {
  const isAgencyFeaturePreferenceEnabled =
    useIsAgencyFeaturePreferenceEnabled();

  const { propertyId } = useParams();
  const { data } = useQuery(listingsModel.queries.read(propertyId));
  if (!data) return null;

  const primaryContact = data.agency_contacts?.[0] ?? data.agency_contacts?.[1];
  const secondaryContact = data.agency_contacts?.[0]
    ? data.agency_contacts?.[1]
    : undefined;

  const primaryContactEmailAddress = primaryContact?.email_address;
  const secondaryContactEmailAddress = secondaryContact?.email_address;

  const address = data.address?.full_address;

  return (
    <HStack justifyContent={"space-between"} flexWrap={"wrap"} gap={4}>
      <VStack alignItems={"flex-start"} w={"100%"}>
        <Heading fontSize={"xl"} fontWeight={600}>
          Marketing material
        </Heading>
        <Flex
          justify={"space-between"}
          w={"100%"}
          direction={{ base: "column", md: "row" }}
          gap={4}
        >
          <Text fontSize={"md"} fontWeight={400} color={"gray.600"}>
            These photos and descriptions will be used across real estate
            portals and other public marketing channels
          </Text>
          {primaryContactEmailAddress &&
          isAgencyFeaturePreferenceEnabled(
            "vendor_portal.functionality.marketing.allow_market_feedback_and_approvals",
          ) ? (
            <MarketingFeedbackButtons
              primaryContact={primaryContact}
              primaryContactEmail={primaryContactEmailAddress}
              secondaryContactEmail={secondaryContactEmailAddress}
              address={address}
              recordId={data.remote_record_id}
            />
          ) : null}
        </Flex>
      </VStack>
    </HStack>
  );
}
